"use client";

import React, { createContext, ReactNode, useState } from "react";

export const isBurgerActiveContext = createContext<any[]>(["", () => {}]);
function BurgerActiveContext({ children }: { children: ReactNode }) {
  const [isActive, setIsActive] = useState(false);

  return (
    <isBurgerActiveContext.Provider value={[isActive, setIsActive]}>
      {children}
    </isBurgerActiveContext.Provider>
  );
}

export default BurgerActiveContext;
